import React from 'react';

import { useClaim } from '~/components/ClaimContainer';
import { PreferredContactContainer } from '~/components/ClaimPage';
import { useCms } from '~/components/hooks/useCms';
import { usePolicy } from '~/components/PolicyContainer';
import { getReinsuranceTextIfNeeded, isReinsuranceManagementClaim } from '~/Utils/ClaimUtils';

import GenericClaimBarField from './GenericClaimBarField';

type PreferredContactProps = {
  displayName?: string;
};

const PreferredContact = ({ displayName = 'Preferred Contact' }: PreferredContactProps) => {
  const { claim, onAsyncClaimUpdate } = useClaim({ claimRequired: true });
  const { userOrganization } = useCms();
  const { policy } = usePolicy();

  const isReinsuranceEnabled = isReinsuranceManagementClaim(claim, userOrganization);

  return (
    <GenericClaimBarField
      title={getReinsuranceTextIfNeeded({
        key: 'preferred_contact',
        isReinsuranceEnabled,
        defaultText: displayName,
      })}
      content={isReinsuranceEnabled ? policy.configured_fields_values?.broker_name || '' : null}
    >
      {isReinsuranceEnabled ? null : <PreferredContactContainer claim={claim} onClaimUpdate={onAsyncClaimUpdate} />}
    </GenericClaimBarField>
  );
};

export default PreferredContact;
